/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState, createContext, useEffect } from "react";
import {
  getLocalStorageData,
  removeLocalStorageData,
} from "../shared/utils/localStorage";

type SidebarContext = {
  toggleSidebar: (value: boolean) => void;
  setPayload: (value: any) => void;
  setAccount: (value: any) => void;
  setEntityName: (value: any) => void;
  entity: { entityName: string; entityTitle: string };
  sidebarToggle: any;
  routes: any;
  payload: any;
  account: any;
};

type PayloadProps = {
  skip: number;
  take: number;
  sortOrder: "DESC" | "ASC" | null;
  sortBy: string | null;
  search: string;
  filter: {};
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SidebarContext = createContext<SidebarContext>(
  {} as SidebarContext
);

const importAll = (context: any) => context.keys().map(context);

export const SidebarProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const filter = getLocalStorageData("filter");
  const accountData = getLocalStorageData("accounts");
  const userData = getLocalStorageData("userData");
  const [routes, setRoutes] = useState();
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [account, setAccount] = useState<any>(
    userData && accountData
      ? accountData
      : { date: { startDate: null, endDate: null, dateFilter: null } }
  );
  const [entity, setEntityName] = useState({
    entityName: "",
    entityTitle: "",
  });
  const [payload, setPayload] = useState<PayloadProps>({
    skip: 0,
    take: 25,
    sortOrder: null,
    sortBy: null,
    search: "",
    filter: filter ? { ...filter, default: null } : null,
  });

  useEffect(() => {
    const routeFilesContext = (require as any).context(
      "../pages",
      true,
      /\/route\/index\.tsx$/
    );
    const routeFiles = importAll(routeFilesContext);
    const routes = routeFiles
      .map((file: any) =>
        Array.isArray(file?.default) ? file?.default : [file?.default]
      )
      .flat();

    //permissions filter
    setRoutes(routes);
  }, []);

  const toggleSidebar = (value: boolean) => {
    setSidebarToggle(value);
  };

  removeLocalStorageData("filter");
  removeLocalStorageData("accounts");

  return (
    <SidebarContext.Provider
      value={{
        toggleSidebar,
        setPayload,
        setAccount,
        setEntityName,
        entity,
        routes,
        payload,
        account,
        sidebarToggle,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
